import { ROUTES } from '@/constants/routes';
import { useContactUnreadCount } from '@/hooks/useContactUnreadCount';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

/**
 * Icône « Messages du site » de l'en-tête, avec pastille du nombre de non-lus.
 * N'est rendue que pour les rôles disposant de la permission 'contact_messages'.
 */
export function ContactInboxButton() {
  const navigate = useNavigate();
  const { allowed, count } = useContactUnreadCount();

  if (!allowed) return null;

  const unread = count ?? 0;

  return (
    <button
      onClick={() => navigate(ROUTES.CONTACT_MESSAGES)}
      className="layout-header-btn-hover relative p-2 rounded-token-md focus:outline-none focus:ring-2 focus:ring-token-focus focus:ring-offset-token-focus transition-colors duration-200"
      aria-label={
        unread > 0
          ? `Messages du site, ${unread} non lu${unread > 1 ? 's' : ''}`
          : 'Messages du site'
      }
      title="Messages du site"
    >
      <EnvelopeIcon className="h-6 w-6" />
      {unread > 0 && (
        <span className="absolute -top-0.5 -right-0.5 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold leading-none">
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </button>
  );
}
